<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="blendComponentForm" :refresh-key="refreshKey" :show-expand="false" />
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                blendComponentForm: () => import('../forms/BlendComponentForm'),
                headers: [
                    { text: 'Blend', value: 'blendId', table: 'blends', form: () => import('../forms/BlendForm') },
                    { text: 'Packer Container', value: 'packerContainerId', table: 'packerContainers', form: () => import('../forms/PackerContainerForm') },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    blends: [],
                    packerContainers: [],
                    items: []
                },
                sorting: [
                    { column: "blendId", direction: "ascending" },
                    { column: "packerContainerId", direction: "ascending" },
                ],
                itemsField: 'blendComponents',
                editPageName: 'blendComponent',
                apiMethod: 'BlendComponents',
                claimName: 'BlendComponents',
                formTitle: 'Blend Component',
                excelTitle: 'Blend Components',
                hasEditPage: false,
            }
        },
    };
</script>
